// extracted by mini-css-extract-plugin
module.exports = {"linkedinWrapper":"LinkedIn_linkedinWrapper__FJNtU","linkedIn":"LinkedIn_linkedIn__2w4pH"};